export default __webpack_public_path__ + "static/alerts_screenshot-crop_signals-lost-options-f19f8fead7309719a2e15166c6507338.webp";